import Alpine from 'alpinejs'
// import collapse from '@alpinejs/collapse' // https://alpinejs.dev/plugins/collapse
// import intersect from '@alpinejs/intersect' // https://alpinejs.dev/plugins/intersect
// import focus from '@alpinejs/focus' // https://alpinejs.dev/plugins/focus

window.Alpine = Alpine // Optional, but nice to have
// Alpine.plugin(collapse)
// Alpine.plugin(intersect)
// Alpine.plugin(focus)
Alpine.start()

// Import fonts (most of the times, you only need the latin subset)
// import '@fontsource/league-spartan/latin-400.css'
